class FavoritePost extends HTMLElement {
  constructor() {
    super();
    this.apiAddUrl = `https://lakanto-usa.herokuapp.com/api/storefront/customer/recipe/set`;
    this.apiGetUrl = `https://lakanto-usa.herokuapp.com/api/storefront/customer/recipe`;
    this.xShopifyDomain = `lakanto-usa.myshopify.com`;
    this.svgButtons = document.querySelectorAll('.add-to-favorite svg');
    this.blogPost = document.querySelectorAll('.add-to-favorite');
    this.modal = document.querySelector('.add-to-favorite-popup');
    this.modalClose = document.querySelector('.add-to-favorite-popup .btn-close');
    this.bindEvents();
    this.checkArticle();
  }
  bindEvents() {
    this.blogPost.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.process();
      });
    });
    this.modalClose.addEventListener('click', (event) => {
      event.preventDefault();
      this.closeModal();
    });
  }
  checkArticle() {
    const body = {
      customer_id: this.dataset.customer,
      article_handle: this.dataset.article,
      type: this.dataset.type,
    };
    const getParams = new URLSearchParams(body).toString();
    this.send(`${this.apiGetUrl}?${getParams}`, 'GET', false, 'add');
  }
  process() {
    if (this.classList.contains('not-logged-in')) {
      this.showModal();
      return;
    }
    const isActive = this.classList.contains('active');
    const body = JSON.stringify({
      customer_id: this.dataset.customer,
      article_handle: this.dataset.article,
      type: this.dataset.type,
      action: isActive ? 'remove' : 'add',
    });
    this.send(this.apiAddUrl, 'POST', body, isActive ? 'remove' : 'add');
  }
  send(url, method, body = false, action = 'add') {
    const config = {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'X-Shop-Domain': this.xShopifyDomain,
      },
    };
    if (body) {
      config['body'] = body;
    }
    fetch(url, config)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (method === 'GET' && data.isset) {
          this.setActive();
        }
        if (method === 'POST' && action === 'add') {
          this.setActive();
        }
        if (method === 'POST' && action === 'remove') {
          this.setInActive();
        }
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
  setActive() {
    this.classList.add('active');
    this.svgButtons.forEach((element) => {
      element.style.fill = '#101820';
    });
  }
  setInActive() {
    this.classList.remove('active');
    this.svgButtons.forEach((element) => {
      element.style.fill = 'none';
    });
  }
  showModal() {
    this.modal.style.display = 'flex';
    document.querySelector('body').style.overflow = 'hidden';
  }
  closeModal() {
    this.modal.style.display = 'none';
    document.querySelector('body').style.overflow = 'auto';
  }
}
customElements.define('favorite-post', FavoritePost);
